<template>
  <v-card flat class="elevation-0 transparent">
    <v-card-text class="pa-0">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <TagsLine :selection="selected" :update-selection="update" :can-edit="canEdit" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { FormErrors } from '@argon/app/components'
import { differenceBy } from 'lodash/array'
import { isString } from 'lodash/lang'
import { NAMESPACE } from '../store'
import { AddonMixin } from '../mixins'

import TagsLine from './TagsLine'
const ADDON = 'tags'

export default {
  name: 'Tags',
  mixins: [AddonMixin],
  components: {
    FormErrors,
    TagsLine
  },
  validations: {
    form: {}
  },
  data: () => ({
    search: null,
    form: {
      text: ''
    },
    addonName: ADDON,
    loading: true
  }),
  methods: {
    ...mapActions(NAMESPACE, ['listLabels']),
    resetForm() {
      this.form = { text: '' }
      this.editingId = null
    },
    add(data) {
      this.resetServerErrors()
      if (!this.$v.form.$invalid) {
        this.createEntityAddon({
          entityURL: this.entity.uris.self,
          addon: this.addonName,
          data
        }).then((result) => {
          this.resetForm()
          this.$v.$reset()
        })
        // .catch(this.setServerErrors)
      } else {
        this.$v.form.$touch()
      }
    },
    update(value) {
      return new Promise((resolve, reject) => {
        let selected = this.matches.map((item) => item.label)
        let newItems = differenceBy(value, selected, 'id')
        let removedItems = differenceBy(selected, value, 'id')
        let toAdd = newItems.map((element) => {
          if (isString(element)) {
            return this.add({ text: element })
          } else {
            return this.add({ label_id: element.id })
          }
        })
        let toRemove = removedItems.map((element) => {
          let match = this.matches.find((item) => item.label.id === element.id)
          return this.remove(match)
        })
        let promises = [...toAdd, ...toRemove]
        Promise.all(promises).then(resolve).catch(reject)
      })
    }
  },
  computed: {
    selected() {
      return this.matches ? this.matches.map((item) => item.label) : []
    }
  }
}
</script>

<i18n>
{
  "en": {
    "addTask": "Add a Task"
  },
  "fr": {
    "addTask": "Ajouter une tache"
  }
}
</i18n>
